import GeozoneDravingPalette from './GeozoneDravingPalette'

export default GeozoneDravingPalette;